import React from 'react';
// import { useMemo } from 'react';
// import { formatDecimalAsPercentage, numeralFormatter } from 'ns_libs/formatter';
// import { useProjectActualsForDeal } from '../../../hooks/useGetProjectActuals';
import { PROJECT_ACTUALS_TYPE } from '../constants';

interface ProjectActualsCellProps {
    dealId: number;
    type: PROJECT_ACTUALS_TYPE;
}

// TODO: re-enable once we have a faster way to get IRR and EMx for the deals table.
const ProjectActualsCell: React.FC<ProjectActualsCellProps> = (_props: ProjectActualsCellProps) => (
    <div>-</div>
);

// const ProjectActualsCell: React.FC<ProjectActualsCellProps> = ({ dealId, type }) => {
//     const { data, isLoading } = useProjectActualsForDeal({ dealId });
//
//     const formattedValue = useMemo(() => {
//         if (!data || !data.returns) {
//             return '-';
//         }
//
//         if (type === PROJECT_ACTUALS_TYPE.IRR) {
//             const irrValue = data.returns.netLeveredIrr;
//             return irrValue ? formatDecimalAsPercentage(irrValue, 2) : '-';
//         }
//
//         if (type === PROJECT_ACTUALS_TYPE.EQUITY_MULTIPLE) {
//             const emValue = data.returns.netLeveredEquityMultiple;
//             return emValue ? `${numeralFormatter(emValue, '0.00')}x` : '-';
//         }
//
//         return '-';
//     }, [data, type]);
//
//     if (isLoading) {
//         return '-';
//     }
//
//     return (
//         <div>
//             {formattedValue}
//         </div>
//     );
// };

export default React.memo(ProjectActualsCell);
